import React from 'react';

const WithErrorBoundary = (WrappedComponent) => (
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = { error: null, errorInfo: null };
    }

    componentDidCatch = (error, errorInfo) => {
      const {catchError} = this.props;
      const errorResult = { error: error, errorInfo: errorInfo }
      if(typeof catchError === 'function'){
        const componentName = WrappedComponent?.type?.name ?? 'unknown';
        catchError(errorResult, componentName)
      }
      return this.setState(errorResult)
    }

    render() {
      const {catchError,...propsResult} = this.props
      if (this.state.errorInfo) {
        if(typeof catchError === 'function'){
          return <React.Fragment/>
        }else{
          return handleError(this)
        }
      }
      // Normally, just render children
      return <WrappedComponent {...propsResult} />;
    }
  }
);


const handleError = (ctx) => (
  // Error path
  <div style={ctx.props.style || styles.error}>
    <h2>Something went wrong.</h2>
    <details style={{ whiteSpace: 'pre-wrap' }}>
      {ctx.state.error && ctx.state.error.toString()}
      <br />
      {ctx.state.errorInfo.componentStack}
    </details>
  </div>
);

const styles = {
  error: {
    backgroundColor: '#f98e7e',
    borderTop: '1px solid #777',
    borderBottom: '1px solid #777',
    padding: '12px',
  }
}

export default WithErrorBoundary;